<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <div>
        <Input
          style="width:200px;margin-right:10px"
          search
          enter-button
          placeholder="输入应用名称"
          @on-search="searchApps"
          v-model="tdata.keyword"
        />
      </div>
      <Table
        stripe
        :columns="tdata.col_data"
        style="margin-top:10px"
        :data="tdata.current_data"
        :loading="tdata.loading"
        @on-row-click="selectItem"
      ></Table>
      <div style="margin-top: 10px;overflow: hidden">
        <div style="text-align:center">
          <Page
            :current.sync="tdata.current_index"
            @on-change="onPageChange"
            :page-size="tdata.page_size"
            :total="tdata.total"
          ></Page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //表头数据
      tdata: {
        keyword: "",
        //数据总量
        total: 0,
        //每页数量
        page_size: 15,
        //当前分页索引
        current_index: 1,
        //是否显示loading框
        loading: true,
        //当前表格数据
        current_data: [],
        col_data: [
          {
            type: "index2",
            width: 80,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                params.index +
                  (this.tdata.current_index - 1) *
                    this.tdata.page_size +
                  1
              );
            },
          },
          {
            title: "应用名称",
            key: "appname",
            width:300
          },
          {
            title: "操作系统",
            key: "platform",
            width:200
          },
          {
            title: "所属项目",
            key: "projectname",
          },
          {
            title: "添加人",
            key: "createdisplayname",
            width:200
          },
          {
            title: "添加日期",
            key: "createtime",
            width:200
          },
        ],
      },
    };
  },
  methods: {
    selectItem(row){
      this.$router.push({
        name: "projectoverview",
        params: { projectguid: row.projectguid },
      });
    },
    searchApps() {
      this.tdata.current_index = 1;
      this.onPageChange(this.tdata.current_index);
    },
    //分页加载项目列表数据
    onPageChange(index) {
      let _this = this;
      this.$http.get({
        method: "mqms/app/getlistall/v2",
        params: {
          keyword: _this.tdata.keyword,
          index: index,
          size: _this.tdata.page_size,
        },
        success: function (data) {
          _this.tdata.loading = false;
          _this.tdata.current_data = data.data;
          _this.tdata.total = data.totalCount;
        },
        failure(code, msg) {
          alert(msg);
        },
      });
    },
  },
  mounted() {
    this.onPageChange(this.tdata.current_index);
  },
};
</script>